export default "__VITE_ASSET__BFBqbHM4__"